var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import isNil from "lodash/isNil";
import isObject from "lodash/isObject";
import { CREATE, DELETE, GET_LIST, GET_MANY, GET_MANY_REFERENCE, GET_ONE, UPDATE, } from "react-admin";
import { buildWhere } from "../buildWhere";
import { buildData } from "./buildData";
import { buildOrderBy } from "./buildOrderBy";
var buildGetListVariables = function (introspectionResults, options) {
    return function (resource, aorFetchType, params) {
        var where = buildWhere(params.filter, resource, introspectionResults, options);
        return {
            skip: (params.pagination.page - 1) * params.pagination.perPage,
            take: params.pagination.perPage,
            orderBy: buildOrderBy(introspectionResults, resource, params === null || params === void 0 ? void 0 : params.sort),
            where: where,
        };
    };
};
var getId = function (introspectionResults, resource, params) {
    var _a, _b;
    var id = (_a = params.id) !== null && _a !== void 0 ? _a : (_b = params.data) === null || _b === void 0 ? void 0 : _b.id;
    var type = introspectionResults.types.find(function (t) { return t.name === resource.type.name + "WhereUniqueInput"; });
    if (!type || type.kind !== "INPUT_OBJECT")
        return id;
    var idType = type.inputFields.find(function (f) { return f.name === "id"; });
    if (!idType || idType.type.kind !== "SCALAR")
        return id;
    if (idType.type.name === "String") {
        id = String(id);
    }
    if (idType.type.name === "Int") {
        id = parseInt(String(id));
    }
    // should usually not happen
    return id;
};
var buildGetOneVariables = function (introspectionResults, options) {
    return function (resource, params) {
        return {
            where: {
                id: getId(introspectionResults, resource, params),
            },
        };
    };
};
var buildUpdateVariables = function (introspectionResults, options) {
    return function (resource, params, parentResource) {
        var _a, _b, _c, _d, _e;
        var inputType = introspectionResults.types.find(function (t) { return t.name === resource.type.name + "UpdateInput"; });
        var id = getId(introspectionResults, resource, params); // TODO: do we still need params.data.id?
        delete params.data.id;
        (_a = params.previousData) === null || _a === void 0 ? true : delete _a.id;
        var data = buildData(inputType, params, introspectionResults);
        return {
            where: {
                id: id,
            },
            data: (_e = (_d = (_c = (_b = options === null || options === void 0 ? void 0 : options.customizeInputData) === null || _b === void 0 ? void 0 : _b[resource.type.name]) === null || _c === void 0 ? void 0 : _c.update) === null || _d === void 0 ? void 0 : _d.call(_c, data, params.data)) !== null && _e !== void 0 ? _e : data,
        };
    };
};
var buildCreateVariables = function (introspectionResults, options) {
    return function (resource, params, parentResource) {
        var _a, _b, _c, _d;
        var inputType = introspectionResults.types.find(function (t) { return t.name === resource.type.name + "CreateInput"; });
        var data = buildData(inputType, params, introspectionResults);
        return {
            data: (_d = (_c = (_b = (_a = options === null || options === void 0 ? void 0 : options.customizeInputData) === null || _a === void 0 ? void 0 : _a[resource.type.name]) === null || _b === void 0 ? void 0 : _b.create) === null || _c === void 0 ? void 0 : _c.call(_b, data, params.data)) !== null && _d !== void 0 ? _d : data,
        };
    };
};
export var buildVariables = function (introspectionResults, options) {
    return function (resource, aorFetchType, params) {
        var _a;
        switch (aorFetchType) {
            case GET_LIST: {
                return buildGetListVariables(introspectionResults, options)(resource, aorFetchType, params);
            }
            case GET_MANY:
                return {
                    where: {
                        id: {
                            in: params.ids
                                .map(function (obj) { return (isObject(obj) ? obj.id : obj); })
                                .filter(function (v) { return !isNil(v); }),
                        },
                    },
                };
            case GET_MANY_REFERENCE: {
                return buildGetListVariables(introspectionResults, options)(resource, GET_LIST, __assign(__assign({}, params), { filter: (_a = {}, _a[params.target] = params.id, _a) }));
            }
            case GET_ONE: {
                return buildGetOneVariables(introspectionResults, options)(resource, params);
            }
            case UPDATE: {
                return buildUpdateVariables(introspectionResults, options)(resource, params);
            }
            case CREATE: {
                return buildCreateVariables(introspectionResults, options)(resource, params);
            }
            case DELETE:
                return {
                    where: { id: params.id },
                };
        }
    };
};
//# sourceMappingURL=index.js.map